'use strict';

const OPT = {__n: 'OPT'};
const REQ = {__n: 'REQ'};
const CB = {__n: 'CB'};
const ND = {__n: 'ND'};

const noop = () => {
};
const last = (a => a[a.length - 1]);
const initial = (a => a[0]);
const isFunction = (a => (a instanceof Function))

function isREQ(a) {
	return a === REQ;
}

function getDefaultValue(a, value) {
	if (arguments.length === 1) {
		value = ND;
	}

	if (a === REQ) {
		if (value === ND) {
			throw new Error('Required argument not provided');
		}
		return value;
	}

	if (a === CB) {
		if (isFunction(value)) {
			return value;
		}
		return noop;
	} else if (a === OPT) {
		if (value === ND) {
			return undefined;
		}
		return value;
	} else if (isFunction(a)) {
		if (value !== ND && a(value)) {
			return value;
		} else {
			return undefined;
		}
	}

	if (value === ND) {
		return a;
	} else {
		return value;
	}
}

function bestMatch(a, rest) {
	let m = -1, i, l;
	for (i = 0, l = rest.length; i < l; i++) {
		let r = rest[i];
		if (r === REQ && m === -1) {
			return i;
		}
		if (r === CB) {
			if (isFunction(a)) {
				return i;
			}
			continue;
		}
		if (isFunction(r)) {
			if (r(a)) {
				// If function returns true - that's it, best match.
				return i;
			} else if (m === -1) {
				// Works like OPT then.
				m = i;
			}
		}
		if (m === -1) {
			// OPT
			m = i;
		}
	}
	return m;
}

/**
 * Slightly easier way to rearrange arguments for method.
 * Usage examples:
 *
 *   * `rearg2(f, rearg2.REQ, rearg2.OPT, rearg2.CB)` - First argument is required,
 *      the second argument can be omitted,
 *      the last argument is callback and will be replaced with `_.noop` if not given.
 *   * `rearg2(f, _.isPlainObject, rearg2.CB)` - first argument expected to be plain object.
 *      If it's not - it will be omitted. The second argument - is callback.
 *   * `rearg2(f, 5)` - 5 will be passed to `f` as first argument if it's not given.
 *
 * @param {function} f - function to wrap.
 * @param {...*} args - arguments definition.
 * @returns {function}
 */
function rearg(f, args) {
	let reargs = Array.from(arguments);
	f = reargs.shift();
	let needed = reargs.find(isREQ);
	let callbackNeeded = last(reargs) === CB;

	if (reargs.length === 0) {
		throw 'Invalid arguments';
	}

	return function reargWrapper() {
		let args = Array.from(arguments);
		let j, l, a, n = needed,
			p, rp, rest = reargs.slice(), fargs = [], cb;

		if (callbackNeeded && isFunction(last(args))) {
			cb = last(args);
			args = initial(args);
			rest = initial(rest);
		}

		while (rest.length) {
			l = args.length;
			if (l < n) {
				throw new Error("Not enough arguments");
			} else if (!l) {
				// No more arguments given, fill with defaults and break
				for (j = 0, p = rest.length; j < p; j++) {
					fargs.push(getDefaultValue(rest[j]));
				}
				break;
			}

			if (l > n) {
				// We have more then needed arguments, let's consume one and do a bestMatch.
				a = args.shift();
				p = bestMatch(a, rest);
				if (p === -1) {
					throw new Error('Arguments don\'t match');
				}
				for (j = 0; j < p; j++) {
					fargs.push(getDefaultValue(rest[j]));
				}
				rp = rest[p];
				fargs.push(getDefaultValue(rp, a));
				if (rp === REQ) {
					n -= 1;
				}
				rest = rest.slice(p + 1);
			} else {
				// Remaining arguments are not enough, so we don't do bestMatch
				rp = rest.shift();
				if (rp === REQ) {
					n -= 1;
					fargs.push(args.shift());
				} else {
					fargs.push(getDefaultValue(rp));
				}
			}
		}
		if (cb) {
			fargs.push(cb);
		}
		return f.apply(this, fargs);
	};
}

rearg.REQ = REQ;
rearg.OPT = OPT;
rearg.CB = CB;

module.exports = rearg;